<template>
  <div class="box" @dragover.prevent @drop.prevent="onDrop">
    <div v-if="!fileUrl" class="upload" draggable="true" @click="open()">
      <Resource
        :src="getFeUrl('/youyan-platform/png/upload-cloud.png')"
        :transform-resource="transformImage"
        class="w-[120px]"
      />
      <a href="javascript:;">
        {{ $t('dian-ji-huo-tuo-zhuai-wen-jian-dao-ci-chu-shang-chuan') }}
      </a>
      <div class="tip">
        {{ $t('jin-zhi-chi-shang-chuan') }}
        <br />
        {{ accept.join('\\').toUpperCase() }}
        | {{ $t('da-xiao') }}{{ ` < ${MAX_SIZE}mb` }}
      </div>
    </div>
    <div v-else class="view">
      <div class="img">
        <video :src="fileUrl" loading="lazy" muted autoplay loop />
      </div>
      <a-button class="flex-center" @click="open()">
        <img
          loading="lazy"
          :src="isDark ? DarkUP : UP"
          class="h-full mr-[4px]"
        />
        {{ $t('zhong-xin-shang-chuan') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { MB_ATOM, transSize, useUpload } from '~/hooks/useUpload'
import UP from '~/assets/svg/up.svg?url'
import DarkUP from '~/assets/svg/up-dark.svg?url'

const emit = defineEmits(['change'])
const { $t } = useNuxtApp()

const currentTheme = useTheme()
const isDark = computed(() => currentTheme?.value === 'dark')

const fileUrl = ref<string>('')
const accept = ['mp4']
const MAX_SIZE = 10

const { open, onDrop } = useUpload({
  accept: '.' + accept.join(',.'),
  noModal: true,
  beforeUpload: (file) => {
    const checkList = accept.filter((item) => file.name.endsWith(item))
    if (checkList.length === 0) {
      message.error($t('qing-shang-chuan-acceptjoin-ge-shi-wen-jian', [accept]))
      return false
    }
    const size = MB_ATOM * 10
    if (file.size > size) {
      message.error(
        $t(
          'feng-mian-da-xiao-bu-neng-chao-guo-transsizesizemb-dang-qian-transsizefilesizemb',
          [transSize(size), transSize(file.size)]
        )
      )
      return false
    }
    if (file?.file) {
      getUrl(file?.file)
    }

    return false
  },
})!

const getUrl = async (file: File) => {
  const reader = new FileReader()
  await reader.readAsDataURL(file)
  reader.onload = () => {
    fileUrl.value = reader.result as string
    emit('change', fileUrl.value)
  }
}

defineExpose({
  fileUrl,
})
</script>

<style lang="scss" scoped>
.box {
  @apply rounded-[8px] w-full h-[532px] relative;
}
.view {
  @apply w-full h-full flex items-center flex-col;
  .img {
    @apply w-full h-[468px] rounded-[8px] bg-back-4 mb-[20px] flex-center;
    > img,
    > video {
      @apply max-w-full max-h-full;
    }
  }
}
.upload {
  @apply rounded-[8px] w-full h-full bg-back-2 flex-center select-none flex-col cursor-pointer;
  border: 1px dashed var(--back-6);
  &:hover {
    @apply bg-purple-2 border-purple-5;
  }
  a {
    @apply text-14 font-semibold;
  }
  .tip {
    @apply text-12 text-font-50 mt-[20px] text-center;
  }
}
</style>
